import { getAuthToken } from '@/utils/local-storage'
import HttpRequest from './HttpRequest'

export default class OrderProvider extends HttpRequest {
  getBills (page, perPage, search, warehouse) {
    this.setHeader(getAuthToken())
    return this.get(`/bills/all?page=${page}&limit=${perPage}&search=${search}&warehouse=${warehouse}`)
  }

  createOrder (payload) {
    this.setHeader(getAuthToken())
    return this.post('/bills', payload)
  }

  updateOrder (id, payload) {
    this.setHeader(getAuthToken())
    return this.put(`/bills?billId=${id}`, payload)
  }

  updateNote (params, payload) {
    this.setHeader(getAuthToken())
    return this.put(`/bills/${params}/note`, payload)
  }

  getBillById (id) {
    this.setHeader(getAuthToken())
    return this.get(`/bills/${id}`)
  }

  deductStock (params) {
    this.setHeader(getAuthToken())
    return this.put(`/bills/${params}/complete`)
  }

  billTracking (params, payload) {
    this.setHeader(getAuthToken())
    return this.put(`/bills/${params}/tracking`, payload)
  }
}
